
import { OC_PLUS_LOGO } from '@marketplace/config/ocplus.js'

export default {
    name: 'BuyOcPlusIntro',

    data() {
        return {
            OC_PLUS_LOGO,
            modalData: {
                title: this.$t('headings.ocplus.buy_modal.title'),
                description: this.$t('headings.ocplus.buy_modal.text'),
                listItems: [
                    this.$t('labels.ocplus.buy_modal.free_shipping_all_orders'),
                    this.$t(
                        'labels.ocplus.buy_modal.5_percent_discount_new_brands'
                    ),
                    this.$t('labels.ocplus.buy_modal.early_access_to_events'),
                    this.$t(
                        'labels.ocplus.buy_modal.10_percent_discount_on_dropshipping_plan'
                    ),
                    this.$t('labels.ocplus.buy_modal.priority_support'),
                ],
                link: {
                    text: this.$t('labels.ocplus.buy_modal.link_text', {
                        ocPlusLogo: OC_PLUS_LOGO.normal.dark,
                    }),
                    url: '/account/plus',
                },
                imageUrl: require('~assets/images/oc-plus/buy-oc-plus-intro.png'),
            },
        }
    },
}
